const protectedSelector = '.product-details, footer, [class*="footer-group"], [role="dialog"], dialog[open]';
let pending = false;

function overlaps(a, b) {
  return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
}

function update() {
  pending = false;
  const zones = [...document.querySelectorAll(protectedSelector)]
    .filter((element) => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden')
    .map((element) => element.getBoundingClientRect());
  const bar = document.querySelector('[ref="stickyBar"][data-stuck="true"]');
  if (bar?.getClientRects().length) {
    const rect = bar.getBoundingClientRect();
    const bottom = Number.parseFloat(getComputedStyle(bar).bottom) || 0;
    zones.push({ left: rect.left, right: rect.right, top: window.innerHeight - bottom - rect.height, bottom: window.innerHeight - bottom });
  }
  const chat = document.querySelector('shopify-chat');
  const runtime = chat?.shadowRoot?.querySelector('shopify-agent-runtime');
  const activator = runtime?.shadowRoot?.querySelector('[part="activator"]');
  const google = document.querySelector('#google-merchantwidget-iframe-wrapper');
  for (const [widget, control] of [[chat, activator], [google, google]]) {
    if (!widget || !control) continue;
    if (widget === chat && chat.hasAttribute('open')) {
      widget.classList.remove('lux-widget-suppressed');
      widget.inert = false;
      continue;
    }
    const rect = control.getBoundingClientRect();
    const conflict = zones.some((zone) => overlaps(rect, zone));
    widget.classList.toggle('lux-widget-suppressed', conflict);
    widget.inert = conflict;
  }
}

function schedule() {
  if (pending) return;
  pending = true;
  requestAnimationFrame(update);
}

document.addEventListener('scroll', schedule, { capture: true, passive: true });
window.addEventListener('resize', schedule, { passive: true });
window.visualViewport?.addEventListener('resize', schedule, { passive: true });
document.addEventListener('transitionend', (event) => {
  if (event.target instanceof Element && event.target.closest('sticky-add-to-cart')) schedule();
});
new MutationObserver(schedule).observe(document.body, {
  subtree: true,
  childList: true,
  attributes: true,
  attributeFilter: ['open', 'data-stuck'],
});
new ResizeObserver(schedule).observe(document.body);
customElements.whenDefined('shopify-chat').then(schedule);
customElements.whenDefined('shopify-agent-runtime').then(schedule);
schedule();
